var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _circle, _polygon7, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GrenadaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M44,24c0-4.857-1.737-9.303-4.617-12.766H8.617C5.737,14.697,4,19.143,4,24 c0,4.854,1.731,9.302,4.607,12.766h30.786C42.269,33.302,44,28.854,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M39.393,11.234C35.724,6.815,30.192,4,24,4S12.276,6.815,8.607,11.234H39.393z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M8.607,36.766C12.276,41.184,17.808,44,24,44s11.724-2.816,15.393-7.234H8.607z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M44,24c0-3.336-0.825-6.475-2.27-9.238L24,24.748l17.079,9.62C42.92,31.342,44,27.801,44,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M4,24c0,3.801,1.08,7.342,2.921,10.368L24,24.748L6.27,14.762C4.825,17.525,4,20.664,4,24z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "24.5,5.991 25.015,7.513 26.622,7.533 25.334,8.494 25.812,10.028 24.5,9.1 23.188,10.028 23.666,8.494 22.378,7.533 23.985,7.513"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "31.773,5.991 32.288,7.513 33.895,7.533 32.607,8.494 33.084,10.028 31.773,9.1 30.461,10.028 30.939,8.494 29.651,7.533 31.257,7.513"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "17.227,5.991 17.743,7.513 19.349,7.533 18.061,8.494 18.539,10.028 17.227,9.1 15.916,10.028 16.393,8.494 15.105,7.533 16.712,7.513"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "24.5,37.564 25.015,39.086 26.622,39.106 25.334,40.067 25.812,41.601 24.5,40.673 23.188,41.601 23.666,40.067 22.378,39.106 23.985,39.086"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "31.773,37.564 32.288,39.086 33.895,39.106 32.607,40.067 33.084,41.601 31.773,40.673 30.461,41.601 30.939,40.067 29.651,39.106 31.257,39.086"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "17.227,37.564 17.743,39.086 19.349,39.106 18.061,40.067 18.539,41.601 17.227,40.673 15.916,41.601 16.393,40.067 15.105,39.106 16.712,39.086"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 4.636,
    fill: "#d50000"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "24.028,19.72 25.001,22.594 28.035,22.632 25.603,24.446 26.505,27.343 24.028,25.59 21.551,27.343 22.453,24.446 20.021,22.632 23.055,22.594"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M9.984,26.268c0,0-0.71-1.065-0.628-2.703c0.874,0.273,2.021,1.393,2.266,1.911 c0.3-2.212-0.055-3.058-1.311-3.522s-2.539-1.311-2.539-1.311s0.087,1.751-0.027,2.266C7.431,24.324,7.981,26.197,9.984,26.268z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M10.775,25.94c-0.519-0.164-1.666-0.464-1.474-2.512C11.185,24.166,10.775,25.476,10.775,25.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GrenadaCircular);
export default __webpack_public_path__ + "static/media/icons8-grenada-circular.c316245474ec9da047335b778acdd956.svg";
export { ForwardRef as ReactComponent };